var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoverage = function SvgCoverage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.799 1.53c-2.427 2.508-4.048 6.632-4.048 10.5 0 3.867 1.872 8.685 4.048 10.5m.362-21a15.83 15.83 0 0 1 4.083 10.5c0 3.855-1.872 8.685-4.083 10.5M2.582 12.006h18.819M3.86 5.368a10.5 10.5 0 1 0 2.007-1.89c-.919.688-1.356 1.11-2.007 1.89"
  })));
};
export default SvgCoverage;